import { useState } from "react";
import appleQrCode from "../assets/images/apple-qr-code.png";

export function QRCode() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="10" y="10" width="50" height="50" rx="4" fill="#1a1a1a" />
      <rect x="18" y="18" width="34" height="34" rx="2" fill="white" />
      <rect x="24" y="24" width="22" height="22" rx="1" fill="#1a1a1a" />
      <rect x="100" y="10" width="50" height="50" rx="4" fill="#1a1a1a" />
      <rect x="108" y="18" width="34" height="34" rx="2" fill="white" />
      <rect x="114" y="24" width="22" height="22" rx="1" fill="#1a1a1a" />
      <rect x="10" y="100" width="50" height="50" rx="4" fill="#1a1a1a" />
      <rect x="18" y="108" width="34" height="34" rx="2" fill="white" />
      <rect x="24" y="114" width="22" height="22" rx="1" fill="#1a1a1a" />
      {[70, 78, 86, 94, 102, 110, 118, 126, 134, 142].map((x) =>
        [10, 18, 26, 34, 42, 50].map((y) =>
          (x + y) % 16 < 8 ? (
            <rect
              key={`${x}${y}`}
              x={x}
              y={y}
              width="6"
              height="6"
              rx="1"
              fill="#1a1a1a"
            />
          ) : null
        )
      )}
      {[10, 18, 26, 34, 42, 50, 58, 66].map((x) =>
        [70, 78, 86, 94, 102, 110, 118, 126, 134, 142].map((y) =>
          (x * 3 + y) % 14 < 7 ? (
            <rect
              key={`d${x}${y}`}
              x={x}
              y={y}
              width="6"
              height="6"
              rx="1"
              fill="#1a1a1a"
            />
          ) : null
        )
      )}
      {[70, 78, 86, 94, 102, 110, 118, 126, 134, 142].map((x) =>
        [70, 78, 86, 94, 102, 110, 118, 126, 134, 142].map((y) =>
          (x + y * 2) % 12 < 5 ? (
            <rect
              key={`e${x}${y}`}
              x={x}
              y={y}
              width="6"
              height="6"
              rx="1"
              fill="#1a1a1a"
            />
          ) : null
        )
      )}
    </svg>
  );
}

export function StoreModal({ store, onClose }) {
  const isIos = store === "ios";
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-2xl p-4 sm:p-6 w-full max-w-sm flex flex-col items-center gap-5 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-4 h-4 text-secondary"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div
          className={`w-14 h-14 rounded-2xl flex items-center justify-center ${isIos ? "bg-black" : "bg-white border border-gray-100 shadow-sm"}`}
        >
          {isIos ? (
            <svg viewBox="0 0 24 24" className="w-8 h-8 fill-white">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" className="w-8 h-8">
              <path fill="#4CAF50" d="M1.22 0L13.4 12 1.22 24H.8V0h.42z" />
              <path fill="#FFD600" d="M16.9 8.6L4.03 1.1 13.4 12l3.5-3.4z" />
              <path
                fill="#F44336"
                d="M4.03 22.9L16.9 15.4 13.4 12 4.03 22.9z"
              />
              <path
                fill="#2196F3"
                d="M21.6 10.8L17.6 8.6 13.4 12l4.2 3.4 4-2.2c.8-.5.8-1.9 0-2.4z"
              />
            </svg>
          )}
        </div>

        <div className="flex flex-col items-center gap-1 text-center">
          <p className="font-manrope-bold text-base text-black">
            {isIos ? "Download on App Store" : "Get it on Google Play"}
          </p>
          <p className="font-manrope-regular text-xs text-secondary">
            Scan the QR code or tap the button below
          </p>
        </div>

        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100">
          {isIos ? (
            <img
              src={appleQrCode}
              alt="App Store QR code"
              className="w-40 h-40 object-contain"
            />
          ) : (
            <QRCode />
          )}
        </div>

        <p className="font-manrope-regular text-xs text-secondary text-center -mt-1">
          Point your camera at the code to install the app
        </p>

        <a
          href={isIos ? "https://apps.apple.com" : "https://play.google.com"}
          target="_blank"
          rel="noreferrer"
          className={`w-full flex items-center justify-center gap-2 py-3 rounded-xl font-manrope-semibold text-sm transition-opacity hover:opacity-90 ${
            isIos ? "bg-black text-white" : "bg-[#01875f] text-white"
          }`}
        >
          {isIos ? "Open App Store" : "Open Google Play"}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
            />
          </svg>
        </a>
      </div>
    </div>
  );
}

export function StoreButtons({ className = "" }) {
  const [modal, setModal] = useState(null);
  return (
    <>
      <div className={`flex flex-wrap gap-3 ${className}`}>
        <button
          onClick={() => setModal("ios")}
          className="flex items-center gap-2.5 bg-white/10 hover:bg-white/20 transition-colors text-white px-4 py-2.5 rounded-xl border border-white/20"
        >
          <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white flex-shrink-0">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
          </svg>
          <div className="text-left leading-tight">
            <p className="font-manrope-regular text-[10px] text-white/70">
              Download on the
            </p>
            <p className="font-manrope-bold text-sm">App Store</p>
          </div>
        </button>

        <button
          onClick={() => setModal("android")}
          className="flex items-center gap-2.5 bg-white/10 hover:bg-white/20 transition-colors text-white px-4 py-2.5 rounded-xl border border-white/20"
        >
          <svg viewBox="0 0 24 24" className="w-5 h-5 flex-shrink-0">
            <path fill="#4CAF50" d="M1.22 0L13.4 12 1.22 24H.8V0h.42z" />
            <path fill="#FFD600" d="M16.9 8.6L4.03 1.1 13.4 12l3.5-3.4z" />
            <path fill="#F44336" d="M4.03 22.9L16.9 15.4 13.4 12 4.03 22.9z" />
            <path
              fill="#2196F3"
              d="M21.6 10.8L17.6 8.6 13.4 12l4.2 3.4 4-2.2c.8-.5.8-1.9 0-2.4z"
            />
          </svg>
          <div className="text-left leading-tight">
            <p className="font-manrope-regular text-[10px] text-white/70">
              Get it on
            </p>
            <p className="font-manrope-bold text-sm">Google Play</p>
          </div>
        </button>
      </div>

      {modal && <StoreModal store={modal} onClose={() => setModal(null)} />}
    </>
  );
}
